// src/pages/UnauthorizedPage.js
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';

const UnauthorizedPage = () => {
  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <Typography variant="h3" component="h1" gutterBottom>
        Acesso Negado!
      </Typography>
      <Typography variant="h6" component="p" gutterBottom>
        Você não tem permissão para acessar esta página.
      </Typography>
      <Box sx={{ mt: 3 }}>
        <Button variant="contained" component={Link} to="/inicial">
          Voltar para Início
        </Button>
      </Box>
    </Container>
  );
};

export default UnauthorizedPage;